import media from '@gtg/utils/media-queries'
import React from 'react'
import styled from 'styled-components'

function addUnit(number, unit) {
  return number + unit
}

function getValueDependingOnType(propsInput, numericBreakpoint) {
  if (typeof propsInput === 'number') {
    return propsInput
  } else if (Array.isArray(propsInput) === true) {
    return propsInput[numericBreakpoint]
  } else {
    return 0
  }
}

function getPadding(propsInput, breakpointNum) {
  const paddingNum = getValueDependingOnType(propsInput, breakpointNum)
  const paddingStr = addUnit(paddingNum, 'rem')
  return paddingStr
}

const StyledBox = styled.div`
  width: 100%;
  padding-top: ${props => getPadding(props.pt, Math.max(0, props.pyMax))};
  padding-right: ${props => getPadding(props.pr, Math.max(0, props.pxMax))};
  padding-bottom: ${props => getPadding(props.pb, Math.max(0, props.pyMax))};
  padding-left: ${props => getPadding(props.pl, Math.max(0, props.pxMax))};
  ${media.xl`
    padding-top: ${props => getPadding(props.pt, Math.max(1, props.pyMax))};
    padding-right: ${props => getPadding(props.pr, Math.max(1, props.pxMax))};
    padding-bottom: ${props => getPadding(props.pb, Math.max(1, props.pyMax))};
    padding-left: ${props => getPadding(props.pl, Math.max(1, props.pxMax))};
  `}
  ${media.lg`
    padding-top: ${props => getPadding(props.pt, Math.max(2, props.pyMax))};
    padding-right: ${props => getPadding(props.pr, Math.max(2, props.pxMax))};
    padding-bottom: ${props => getPadding(props.pb, Math.max(2, props.pyMax))};
    padding-left: ${props => getPadding(props.pl, Math.max(2, props.pxMax))};
  `}
  ${media.md`
    padding-top: ${props => getPadding(props.pt, Math.max(3, props.pyMax))};
    padding-right: ${props => getPadding(props.pr, Math.max(3, props.pxMax))};
    padding-bottom: ${props => getPadding(props.pb, Math.max(3, props.pyMax))};
    padding-left: ${props => getPadding(props.pl, Math.max(3, props.pxMax))};
  `}
  ${media.sm`
    padding-top: ${props => getPadding(props.pt, Math.max(4, props.pyMax))};
    padding-right: ${props => getPadding(props.pr, Math.max(4, props.pxMax))};
    padding-bottom: ${props => getPadding(props.pb, Math.max(4, props.pyMax))};
    padding-left: ${props => getPadding(props.pl, Math.max(4, props.pxMax))};
  `}
  ${media.xs`
    padding-top: ${props => getPadding(props.pt, Math.max(5, props.pyMax))};
    padding-right: ${props => getPadding(props.pr, Math.max(5, props.pxMax))};
    padding-bottom: ${props => getPadding(props.pb, Math.max(5, props.pyMax))};
    padding-left: ${props => getPadding(props.pl, Math.max(5, props.pxMax))};
  `}
`

const Box = props => {
  const pt = props.pt
  const pr = props.pr
  const pb = props.pb
  const pl = props.pl
  const px = props.px
  const py = props.py
  const p = props.p
  const pxMax = props.pxMax
  const pyMax = props.pyMax
  const pMax = props.pMax

  function assignTopPadding() {
    if (pt || pt === 0) {
      return pt
    } else if (py || py === 0) {
      return py
    } else if (p || p === 0) {
      return p
    } else {
      return [12, 8, 4, 3, 2, 1]
    }
  }

  function assignRightPadding() {
    if (pr || pr === 0) {
      return pr
    } else if (px || px === 0) {
      return px
    } else if (p || p === 0) {
      return p
    } else {
      return [12, 8, 4, 3, 2, 1]
    }
  }

  function assignBottomPadding() {
    if (pb || pb === 0) {
      return pb
    } else if (py || py === 0) {
      return py
    } else if (p || p === 0) {
      return p
    } else {
      return [12, 8, 4, 3, 2, 1]
    }
  }

  function assignLeftPadding() {
    if (pl || pl === 0) {
      return pl
    } else if (px || px === 0) {
      return px
    } else if (p || p === 0) {
      return p
    } else {
      return [12, 8, 4, 3, 2, 1]
    }
  }

  function maxStrToNum(maxStr) {
    switch (maxStr) {
      case 'xl':
        return 1
      case 'lg':
        return 2
      case 'md':
        return 3
      case 'sm':
        return 4
      case 'xs':
        return 5
      default:
        return 0
    }
  }
  return (
    <StyledBox
      pt={assignTopPadding()}
      pr={assignRightPadding()}
      pb={assignBottomPadding()}
      pl={assignLeftPadding()}
      pxMax={Math.max(maxStrToNum(pMax), maxStrToNum(pxMax))}
      pyMax={Math.max(maxStrToNum(pMax), maxStrToNum(pyMax))}
      className={props.className}
    >
      {props.children}
    </StyledBox>
  )
}

export default Box
